import { FallcoClass } from '../classes/FallcoClass';

import 'mdn-polyfills/Object.entries';
import '../polyfills/Console.table';

class Performance extends FallcoClass {
  constructor() {
    super();
    
    this.tests = {};
    
    return super.expose_to_public('performance', this);
  }
  
  testMethod(method, message) {
    if (!method) {
      throw new Error('E\' necessario specificare il metodo da testare.');
    }
    
    const methodName = (method.name || message).toSnakeCase();
    
    if (!this.tests[methodName]) {
      this.tests[methodName] = {
        start:   [],
        end:     [],
        tot:     [],
        average: 0
      };
    }
    
    const start = window.performance.now();
    const toReturn = method();
    
    const end = window.performance.now();
    const tot = end - start;
    
    this.tests[methodName].start.push(start);
    this.tests[methodName].end.push(end);
    this.tests[methodName].tot.push(tot);
    this.tests[methodName].average = this._calculateAverage(this.tests[methodName].tot);
    
    console.log(message, tot);
    
    return toReturn;
    // return this.tests[methodName];
  }
  
  getAverage() {
    var averageList = [];
    
    Object.entries(this.tests).forEach(function(entry) {
      averageList.push({
        'Nome':          entry[0],
        'Test Eseguiti': `${entry[1].tot.length}`,
        'Media ms':      entry[1].average
      });
    });
    
    console.table(averageList);
  }
  
  /**
   *
   * @param {Array} data
   * @private
   */
  _calculateAverage(data) {
    var length = data.length;
    var sum    = data.reduce(function(acc, curr) {
      acc += curr;
      
      return acc;
    }, 0);
    
    return sum / length;
  }
}

export default new Performance();
